import React from 'react';

const Header = () => {
  const instaIconStyle = {
    height: '20px',
    width: 'auto',
    marginRight: '15px',
    opacity: '0.6'
  };
  return (
    <div style={{ padding: '44px 65px 0' }} className="d-f justify-content-sb align-items-fs">
      <a href="http://buvanamurali.com">
        <span style={{ letterSpacing: '0.18em' }} className="d-b ff-hl fz-20 lh-1pt4 c-b1b0b0 tt-u">
          Buvana Murali
        </span>
        <span style={{ letterSpacing: '1.95em', marginLeft: '1px' }} className="ff-hb fz-12 c-6c6c6c tt-u">
          gallery
        </span>
      </a>
      <div className="d-f align-items-c">
        <a className="fz-0" href="https://www.instagram.com/buvanam/" target="_blank">
          <img
            style={instaIconStyle}
            src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii01MTAuNSAzMjUuNCA5MCA5MCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAtNTEwLjUgMzI1LjQgOTAgOTA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwYXRoIGQ9Ik0tNDM2LjMsMzI1LjRoLTU4LjNjLTguNywwLTE1LjgsNy4xLTE1LjgsMTUuOHY1OC4zYzAsOC43LDcuMSwxNS44LDE1LjgsMTUuOGg1OC4zYzguNywwLDE1LjgtNy4xLDE1LjgtMTUuOHYtNTguMw0KCUMtNDIwLjUsMzMyLjUtNDI3LjYsMzI1LjQtNDM2LjMsMzI1LjR6IE0tNDQ2LjIsMzM0LjZjMC0xLjUsMS4yLTIuNywyLjctMi43aDEwLjRjMS41LDAsMi43LDEuMiwyLjcsMi43VjM0NWMwLDEuNS0xLjIsMi43LTIuNywyLjcNCgloLTEwLjRjLTEuNSwwLTIuNy0xLjItMi43LTIuN0wtNDQ2LjIsMzM0LjZMLTQ0Ni4yLDMzNC42eiBNLTQ0OS4xLDM2OS41YzAsOC45LTcuMywxNi4yLTE2LjIsMTYuMmMtOC45LDAtMTYuMi03LjMtMTYuMi0xNi4yDQoJczcuMy0xNi4yLDE2LjItMTYuMkMtNDU2LjQsMzUzLjMtNDQ5LjEsMzYwLjYtNDQ5LjEsMzY5LjV6IE0tNDMwLjMsMzk5LjVjMCwzLjMtMi43LDYtNiw2aC01OC4zYy0zLjMsMC02LTIuNy02LTZ2LTQxLjZoMTIuMQ0KCWMtMS44LDMuNS0yLjgsNy41LTIuOCwxMS43YzAsMTQuMywxMS43LDI2LDI2LDI2YzE0LjMsMCwyNi0xMS43LDI2LTI2YzAtNi4zLTIuMi0xMi02LTE2LjVoMTVWMzk5LjV6Ii8+DQo8L3N2Zz4NCg=="
          />
        </a>
        <p className=" ff-qsl fz-13 lh-1pt4 c-b1b0b0 tt-l">
          email:&nbsp;buvana.m@gmail.com<br />phone:&nbsp;+1 917 215 9106
        </p>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js